import { List } from 'immutable';
import { createSelector } from 'reselect';
import { BaseState } from '../../../entities/BaseState';
import { ModalState } from '../entities/IModalState';

const getModalItemsSelector = (state: BaseState) => (state.modals ? state.modals.items : null);

const getModalItems = createSelector(
	[getModalItemsSelector],
	(data: List<ModalState>): List<ModalState> => data
);

export { getModalItems };
